
export function ordernar(a: any, b: any ) {
   
   return (Number(a.titulo) > Number(b.titulo)) ? 1 : ((Number(b.titulo) > Number(a.titulo)) ? -1 : 0)
}